import { NeuSnackbar } from "@neutron/react";

interface SnackbarProps {
  kind?: "info" | "success" | 'error' | 'warning';
  label?: string;
  className?: string;
  message?: string;
  buttonText?: string;
  teleport?:boolean;
  onClick?: (e: any) => void;
  onDismiss?: (e: any) => void;
}

export function Snackbar({
    kind = "info",
    label = "",
    className = "",
    message = "",
    buttonText = "Confirm",
    teleport = false,
    onClick,
    onDismiss
    }: SnackbarProps) {
    return(
        <div>
            <NeuSnackbar
                kind={kind}
                label={label}
                className={className}
                message={message}
                button={buttonText}
                teleport={teleport}
                onNeuClick={onClick}
                onNeuDismiss={onDismiss}
            />
        </div>
        
    )}


